<template>
    <div class="custom-order-select">
        <div>
            <div @click="open=!open">
                <div>
                    <p class="mb-0">
                        <b v-if="selected">
                            <span>{{selected.name}}</span>
                            <span :class="selected.dir==='up'? 'mdi mdi-arrow-up' : 'mdi mdi-arrow-down'"></span>
                        </b>
                        <b v-else>{{placeholder}}</b>
                    </p>
                </div>
            </div>
            <transition name="dropdown">
                <div class="dropdown-list" v-show="open" @mouseleave="open = false">
                    <div v-for="(item, index) in list" :key="index" :class="item.dir" @click="onClick(item)">
                        <span>{{item.name}}</span>
                        <span :class="item.dir==='up'? 'mdi mdi-arrow-up' : 'mdi mdi-arrow-down'"></span>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
export default {
  name: 'CustomOrderSelect',
  props: {
    value: {
      type: Object,
      default () {
        return {name: 'prezzo', dir: 'up'}
      }
    },
    placeholder: {
      type: String,
      default: 'Ordina per'
    },
    list: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      selected: this.value,
      open: false
    }
  },
  methods: {
    onClick (item) {
      this.$emit('change', item)
      this.open = false
      this.selected = item
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/common/CustomOrderSelect.vue